// extracted by mini-css-extract-plugin
export default {"ArrowUp":"arrow_ArrowUp__pRHDK","ArrowDown":"arrow_ArrowDown__kCFGh"};